import ToggleSwitch from "../atomic/ToggleSwitch";

export interface OrganizationPreferenceRow {
  id: string;
  name: string;
  externalEnabled: boolean;
  statusLabel: string;
  hasOverride: boolean;
}

interface OrganizationsPreferencesListProps {
  organizations: OrganizationPreferenceRow[];
  onToggleExternal: (orgId: string, enabled: boolean) => void;
  onCustomize: (orgId: string) => void;
  readOnly?: boolean;
}

function OrganizationsPreferencesList({
  organizations,
  onToggleExternal,
  onCustomize,
  readOnly = false,
}: OrganizationsPreferencesListProps): JSX.Element {
  if (organizations.length === 0) {
    return (
      <p className="py-4 text-sm text-textSecondaryGray">
        No organizations found for your account.
      </p>
    );
  }

  return (
    <div className="overflow-auto border border-dropDownBorder rounded-md">
      <table className="table-fixed w-full bg-white">
        <colgroup>
          <col className="w-[32%]" />
          <col className="w-[28%]" />
          <col className="w-[22%]" />
          <col className="w-[18%]" />
        </colgroup>
        <thead className="bg-sideNavGray">
          <tr className="text-left text-sm text-royalBlue">
            <th className="px-4 py-3 font-semibold">Organization</th>
            <th className="px-4 py-3 font-semibold">Status</th>
            <th className="px-4 py-3 font-semibold">External notifications</th>
            <th className="px-4 py-3 font-semibold text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          {organizations.map((org) => (
            <tr
              key={org.id}
              className="border-t border-dropDownBorder text-sm text-royalBlue"
            >
              <td className="px-4 py-3 font-semibold truncate">
                {org.name}
              </td>
              <td className="px-4 py-3 text-textSecondaryGray">
                <span className="block truncate whitespace-nowrap">
                  {org.externalEnabled ? org.statusLabel : "Off · Portal only"}
                </span>
              </td>
              <td className="px-4 py-3">
                <div className="flex items-center">
                  <ToggleSwitch
                    name={`external-${org.id}`}
                    id={`external-${org.id}`}
                    checked={org.externalEnabled}
                    disabled={readOnly}
                    handleChange={() =>
                      onToggleExternal(org.id, !org.externalEnabled)
                    }
                  />
                </div>
              </td>
              <td className="px-4 py-3 text-right whitespace-nowrap">
                <button
                  type="button"
                  className="text-primary font-semibold"
                  onClick={() => onCustomize(org.id)}
                  disabled={readOnly}
                >
                  Customize →
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default OrganizationsPreferencesList;
